import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { UpploadService } from "../service";
import { imageUrlToBlob, cachedFetch } from "./http";
import { colorSVG } from "./assets";
import { safeListen } from "./elements";
import { blobToUpploadFile } from "./files";

var generateFileName = function generateFileName(file, service) {
  file.name = "".concat(service, "-import-").concat(Math.random().toString(36).slice(2));
  return file;
};

export var MicrolinkBaseClass = /*#__PURE__*/function (_UpploadService) {
  _inherits(MicrolinkBaseClass, _UpploadService);

  var _super = _createSuper(MicrolinkBaseClass);

  function MicrolinkBaseClass() {
    var _this;

    _classCallCheck(this, MicrolinkBaseClass);

    _this = _super.apply(this, arguments);
    _this.loading = false;
    _this.exampleURL = "";

    _this.validator = function () {
      return true;
    };

    _this.template = function (_ref) {
      var translate = _ref.translate;
      return "\n      <div class=\"microlink-container\">\n      <form class=\"microlink-search-form\">\n        <div class=\"service-icon\">".concat(colorSVG(_this.icon, _assertThisInitialized(_this)), "</div>\n        <label>\n          <span>").concat(translate("services.".concat(_this.name, ".label")) || translate("services.microlink.label", [translate("services.".concat(_this.name, ".title")) || _this.name, translate("services.".concat(_this.name, ".type")) || translate("services.microlink.type")]), "</span>\n          <input class=\"microlink-search-input\" type=\"url\" placeholder=\"").concat(translate("services.".concat(_this.name, ".placeholder")) || translate("services.microlink.placeholder", [translate("services.".concat(_this.name, ".title")) || _this.name, translate("services.".concat(_this.name, ".type")) || translate("services.microlink.type")]) || "", "\" required>\n        </label>\n        <button type=\"submit\" style=\"background: ").concat(_this.color, "\">").concat(translate("services.".concat(_this.name, ".button")) || translate("services.microlink.button", translate("services.".concat(_this.name, ".title")) || _this.name), "</button></form><button class=\"need-help-link\"><span>").concat(translate("needHelp"), "</span aria-hidden=\"true\"><span>?</span></button></div>\n    <div class=\"uppload-loader microlink-loader\">\n    <div></div>\n    <p>").concat(translate("services.".concat(_this.name, ".loading")) || translate("services.microlink.loading", translate("services.".concat(_this.name, ".title")) || _this.name) || translate("fetching", translate("services.".concat(_this.name, ".title"))), "</p>\n  </div>");
    };

    _this.handlers = function (params) {
      var form = params.uppload.container.querySelector(".microlink-search-form");

      if (form) {
        safeListen(form, "submit", function (event) {
          event.preventDefault();
          var input = params.uppload.container.querySelector(".microlink-search-input");

          if (input) {
            var url = input.value;
            if (!_this.validator(url)) return params.handle(new Error("errors.invalid_url"));
            _this.loading = true;

            _this.update(params);

            if (_this.name === "screenshot") {
              imageUrlToBlob("https://api.microlink.io?url=".concat(encodeURIComponent(url), "&screenshot=true&meta=false&embed=screenshot.url")).then(function (blob) {
                return params.next(generateFileName(blobToUpploadFile(blob), _this.name));
              }).catch(function (error) {
                return params.handle(error);
              }).then(function () {
                return _this.loading = false;
              });
            } else if (_this.name === "url") {
              imageUrlToBlob(url).then(function (blob) {
                return params.next(generateFileName(blobToUpploadFile(blob), _this.name));
              }).catch(function (error) {
                return params.handle(error);
              });
            } else {
              cachedFetch("https://api.microlink.io/?url=".concat(encodeURIComponent(url))).then(function (result) {
                if (!result.data.image || !result.data.image.url) throw new Error("errors.response_not_ok");
                return result.data.image.url;
              }).then(function (url) {
                return imageUrlToBlob(url);
              }).then(function (blob) {
                return params.next(generateFileName(blobToUpploadFile(blob), _this.name));
              }).catch(function (error) {
                return params.handle(error);
              });
            }
          }

          return false;
        });
      }

      var helpButton = params.uppload.container.querySelector(".need-help-link");
      if (helpButton) safeListen(helpButton, "click", function () {
        return params.showHelp("/services/".concat(["url", "screenshot"].indexOf(_this.name) !== -1 ? _this.name : "import-from-web-service/".concat(_this.name)));
      });
    };

    return _this;
  }

  _createClass(MicrolinkBaseClass, [{
    key: "update",
    value: function update(params) {
      var loader = params.uppload.container.querySelector(".microlink-loader");
      var container = params.uppload.container.querySelector(".microlink-container");
      if (container) container.style.display = this.loading ? "none" : "";
      if (loader) loader.style.display = this.loading ? "flex" : "none";
    }
  }]);

  return MicrolinkBaseClass;
}(UpploadService);